// khasAuth.js — Auth utilities Zona KHAS (API version)
// Letakkan di: src/component/khas/khasAuth.js

import { authApi } from './khasApi'

const SESSION_KEY = 'khas_session'
const TOKEN_KEY   = 'khas_token'

// ── Session (disimpan di localStorage) ───────────────────
export function getSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) : null
  } catch { return null }
}

export function saveSession(user, token) {
  localStorage.setItem(SESSION_KEY, JSON.stringify(user))
  localStorage.setItem(TOKEN_KEY, token)
}

export function logout() {
  localStorage.removeItem(SESSION_KEY)
  localStorage.removeItem(TOKEN_KEY)
}

// ── Login ─────────────────────────────────────────────────
export async function login(username, password) {
  try {
    const data = await authApi.login({ username, password })
    saveSession(data.user, data.token)
    return { ok: true, session: data.user }
  } catch (err) {
    return { ok: false, msg: err.message }
  }
}

// ── Ganti password ────────────────────────────────────────
export async function gantiPassword(passwordLama, passwordBaru) {
  try {
    await authApi.gantiPassword({
      password_lama: passwordLama,
      password_baru: passwordBaru,
    })
    // Update is_first_login di session lokal
    const session = getSession()
    if (session) {
      saveSession({ ...session, is_first_login: false },
        localStorage.getItem(TOKEN_KEY))
    }
    return { ok: true }
  } catch (err) {
    return { ok: false, msg: err.message }
  }
}

// ── Update first login (dipanggil setelah ganti password) ─
export function updateFirstLogin(userId) {
  const session = getSession()
  if (session && session.id === userId) {
    saveSession({ ...session, is_first_login: false },
      localStorage.getItem(TOKEN_KEY))
  }
}

// ── Users (admin) ─────────────────────────────────────────
export function getUsers() {
  // Sekarang dari API — dipanggil langsung di AdminTab
  // Fungsi ini tetap ada untuk backward compatibility
  return []
}

export async function addUser(newUser) {
  const { usersApi } = await import('./khasApi')
  return usersApi.create(newUser)
}

export async function deleteUser(id) {
  const { usersApi } = await import('./khasApi')
  return usersApi.delete(id)
}

export async function updateUserPassword(id, passwordBaru) {
  const { usersApi } = await import('./khasApi')
  return usersApi.resetPassword(id, { password_baru: passwordBaru })
}

// ── Role check ────────────────────────────────────────────
const ROLE_LEVEL = { kdeks: 1, pemda: 1, admin: 2, superadmin: 3 }

export function canAccess(session, minRole) {
  if (!session) return false
  return (ROLE_LEVEL[session.role] || 0) >= (ROLE_LEVEL[minRole] || 0)
}

export function ROLE_LABEL(role) {
  return {
    kdeks: 'KDEKS', pemda: 'PEMDA',
    admin: 'Admin', superadmin: 'Super Admin'
  }[role] || role
}